<template>
  <v-main>
    <slot />
  </v-main>
</template>

<script lang="ts">
export default defineComponent({})
</script>
